import script from "./RoutePvs.vue?vue&type=script&lang=ts&setup=true"
export * from "./RoutePvs.vue?vue&type=script&lang=ts&setup=true"

import "./RoutePvs.vue?vue&type=style&index=0&id=4d68a800&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d68a800"]])

export default __exports__